export default __webpack_public_path__ + "b82fc1b896236a889aa35585c1e8de69.png";